var exports = {
  "fI": "Row__5sE3ej",
  "UC": "Content__9KzMNW",
  "yL": "Children__LznhHC",
  "VY": "Description__b5HyKm",
  "Jc": "LeadingVisual__SlkBwL",
};

module.exports = exports;
